module.exports = __webpack_public_path__ + "img/warning.32d4784f.svg";